import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: Mail,
      label: 'Email',
      value: 'Admin@radiuscleaningcompany.com',
      link: 'mailto:Admin@radiuscleaningcompany.com'
    },
    {
      icon: Phone,
      label: 'Phone',
      value: '404-750-4446',
      link: 'tel:404-750-4446'
    },
    {
      icon: MapPin,
      label: 'Location',
      value: 'Georgia, USA',
      link: null
    },
    {
      icon: Clock,
      label: 'Hours',
      value: (
        <>
          <span className="block">Service: Sunday – Saturday</span>
          <span className="block">Administration: 9AM – 5PM</span>
        </>
      ),
      link: null
    }
  ];

  return (
    <section id="contact" className="py-32" style={{ background: '#F3F4F6' }}>
      <div className="container mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span
            className="text-xs font-bold tracking-[0.2em] uppercase mb-4 inline-block"
            style={{ color: '#0284C7' }}
          >
            GET IN TOUCH
          </span>
          <h2
            className="text-3xl sm:text-4xl tracking-tight font-medium mb-6"
            style={{ fontFamily: 'Outfit', color: '#0F172A' }}
          >
            Contact Radius Cleaning Company
          </h2>
          <p className="text-base leading-relaxed max-w-2xl mx-auto" style={{ color: '#475569' }}>
            Ready to experience the royal treatment? Get in touch with us today
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {contactInfo.map((info, index) => (
              <motion.div
                key={info.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl p-8 hover-lift"
                style={{ border: '1px solid #E2E8F0' }}
                data-testid={`contact-card-${index}`}
              >
                <info.icon className="w-10 h-10 mb-4" style={{ color: '#0284C7' }} />
                <h4 className="text-lg font-medium mb-2" style={{ color: '#0F172A' }}>
                  {info.label}
                </h4>
                {info.link ? (
                  <a
                    href={info.link}
                    className="text-base hover:opacity-70 transition-opacity"
                    style={{ color: '#475569' }}
                  >
                    {info.value}
                  </a>
                ) : (
                  <p className="text-base" style={{ color: '#475569' }}>
                    {info.value}
                  </p>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="inline-flex items-center gap-32 py-6 px-12 rounded-full glassmorphism">
            <span className="text-sm font-bold tracking-[0.2em] uppercase" style={{ color: '#0284C7' }}>
              TRUSTED BY GEORGIA BUSINESSES
            </span>
            <span className="text-sm font-bold tracking-[0.2em] uppercase" style={{ color: '#0284C7' }}>
              FULLY INSURED
            </span>
          </div>
        </motion.div>

        <motion.footer
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-16 pt-8 text-center"
          style={{ borderTop: '1px solid #E2E8F0' }}
        >
          <p className="text-sm" style={{ color: '#475569' }}>
            © {new Date().getFullYear()} Radius Cleaning Company LLC. All rights reserved.
          </p>
        </motion.footer>
      </div>
    </section>
  );
};

export default Contact;